/**
 * Matches backend _compute_upload_file_fingerprint for metadata precheck reuse.
 */
export async function computeUploadFileFingerprint(file: File): Promise<string> {
  const chunkSize = 256 * 1024;
  const slice = file.slice(0, Math.min(chunkSize, file.size));
  const chunk = new Uint8Array(await slice.arrayBuffer());
  const sizePart = new TextEncoder().encode(String(file.size));
  const namePart = new TextEncoder().encode(file.name);
  const combined = new Uint8Array(sizePart.length + namePart.length + chunk.length);
  combined.set(sizePart, 0);
  combined.set(namePart, sizePart.length);
  combined.set(chunk, sizePart.length + namePart.length);
  const digest = await crypto.subtle.digest('SHA-256', combined);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')
    .slice(0, 32);
}
